<template>
  <div class="page_box">
    <img class="img_page_box_background" src="@/assets/images/scancodebg.png" />
    <div class="page_inner">
      <div class="box-inner-scan">
        <button class="sweep">
          <input
            type="file"
            ref="upInputImage"
            @change="upload($event)"
          />扫一扫
        </button>
        <div class="scancode-box" @click="upLOadeImage($event)">
          <img src="@/assets/images/NFC-1.png" class="scancode-class" />
          <img
            src="@/assets/images/NFC-2.png"
            class="scancode-class scancode-two"
          />
          <img
            src="@/assets/images/NFC-3.png"
            class="scancode-class scancode-one"
          />
          <!-- <img src="" alt=""> -->
          <img src="@/assets/images/leftcode.png" class="leftcode-scan" />
          <img src="@/assets/images/leftcode.png" class="rightcode-scan" />
        </div>
      </div>
      <div class="bottom-tips">
        <span>扫码识别</span>
        <!-- <span bindtap="linkCheck">如何查验真伪？</span> -->
      </div>
      <div class="bottom-tips-template">
        <div class="tips-template-list">一物一码</div>
        <div class="tips-template-list">拒绝假货</div>
        <div class="tips-template-list">正品保证</div>
      </div>
    </div>
  </div>
</template>

<script>
import jsQR from "jsqr";
import Jimp from "jimp";
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
export default {
  name: "Index",
  data() {
    return {
      result: "1e890af05b0c4e9d836d21f6481d9f55",
    };
  },
  created() {
    localStorage.clear();
    
  },
  components: {},
  methods: {
    upLOadeImage() {
      this.$refs.upInputImage.dispatchEvent(new MouseEvent("click"));
    },
    // handleScanCode() {
    //   // this.$router.push("/goodsInfo");
    // },
    upload(e) {
      const file = e.target.files[0];
      const createObjectURL =
        window.createObjectURL ||
        window.URL.createObjectURL ||
        window.webkitURL.createObjectUR;
      this.result = "";
      this.imgurl = createObjectURL(file);
      const fReader = new FileReader();
      this.$lrz(file, {
        width: 500,
      }).then((re) => {
        console.log("压缩完成");
        fReader.readAsDataURL(re.file); // Base64 8Bit字节码
        // fReader.readAsBinaryString(file);  // Binary 原始二进制
        // fReader.readAsArrayBuffer(file);   // ArrayBuffer 文件流
        const toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "识别中",
        });
        fReader.onload = (e) => {
          this.imgurl2 = e.target.result;

          e.target.result &&
            Jimp.read(e.target.result)
              .then(async (res) => {
                const { data, width, height } = res.bitmap;
                try {
                  const resolve = await jsQR(data, width, height);

                  let indexOfUrl = resolve.data.indexOf("?");

                  this.result = resolve.data.slice(indexOfUrl);

                  let urlParms = this.GetRequest(this.result);
                  console.info("识别结果：", resolve.data);

                  const { data: re } = await this.$api.getDataApi(
                    urlParms.id,
                    urlParms.batch_code,
                    urlParms.merchant_id,
                    urlParms.t
                  );
                  console.log(re);
                  if (re.code === 200) {
                    console.log(JSON.parse(re.data));
                    
                    let second = 1;
                    const timer = setInterval(() => {
                      second--;
                      if (second) {
                        toast.message = re.mag;
                      } else {
                        clearInterval(timer);
                        // 将数据根据id用Map格式存储
                        let dataObjcach = JSON.parse(re.data).data_list;
                        let listsTg = JSON.parse(re.data).lists;
                        //遍历 将每个环节数据内容数据json字符串转为对象
                        let mapData = new Object();
                        console.log(dataObjcach, "有数据吗")
                        if(!dataObjcach) return Toast('暂无数据')
                        dataObjcach.forEach((element) => {
                          mapData[element.trace_id] = element;
                          if (element.msgItems) {
                            element.msgItems.forEach((value) => {
                              value.op.op = JSON.parse(value.op.op);
                            });
                          }
                        });

                        localStorage.setItem(
                          "idInObj",
                          JSON.stringify(mapData)
                        );
                        localStorage.setItem(
                          "defalutObj",
                          JSON.stringify(dataObjcach)
                        );
                        // t=1标识 t=2包装
                        // 将推广信息按钮配置存储在本地
                        localStorage.setItem("lists",JSON.stringify(listsTg))
                        // 存储获取请求的id数据
                        localStorage.setItem("id", urlParms.id);
                        localStorage.setItem("batch_Code", urlParms.batch_code);
                        // 存储额外的信息
                        // localStorage.setItem('PublicInfo',JSON.stringify(re.data.data.msg[0]))
                        //跳转商品信息   默认跳转对象中的第一个数据
                        this.$router.push(`/goodsInfo?defaultId=1`);
                        // 手动清除 Toast
                        Toast.clear();
                      }
                    }, 1000);
                  } else {
                    Toast(res.msg);
                    return;
                  }
                } catch (err) {
                  Toast.clear();
                  Toast("识别失败，请检查二维码是否正确");
                  this.result = "识别失败，请检查二维码是否正确！";
                  console.error("识别失败，请检查二维码是否正确！", err);
                } finally {
                  console.info("读取到的文件：", res);
                }
              })
              .catch((err) => {
                console.error("文件读取错误：", err);
              });
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* pages/scan_code/scan_code.wxss */
// page{

// }
.sweep{
  display: none;
}
.page_box {
  width: 100%;
  height: 100vh;
  background-color: #2c2e41;
  display: flex;
  align-items: center;
}
.page_inner {
  width: 100%;
}
.page_box img.img_page_box_background {
  width: 100%;
  /* height: 1180px; */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.page_inner {
  position: relative;
  margin-bottom: 120px;
  z-index: 2;
  height: auto;
}
.scancode-box {
  width: 100%;
  height: 490px;
  /* background: skyblue; */
  position: relative;
  /* padding-top: 120px; */
  display: flex;
  justify-content: center;
}
.scancode-box img.scancode-class {
  width: 490px;
  height: 490px;
  position: absolute;
  left: 50%;
  margin-left: -245px;
}
.leftcode-scan {
  width: 166px;
  height: 51px;
  position: absolute;
  z-index: 99;
  left: 0;
  top: 50%;
  margin-top: -25px;
}
.bottom-tips {
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  align-items: center;
  // span-align: center;
}
.bottom-tips span:nth-child(1) {
  color: #fff;
  font-size: 32px;
  margin: 48px 0;
}
.bottom-tips span:nth-child(2) {
  color: #9da5b2;
  font-size: 24px;
  /* margin:48px 0; */
}
.bottom-tips-template {
  /* width: 414px; */
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-top: 210px;
}
.box-inner-scan {
  padding-top: 120px;
}
.tips-template-list {
  width: 186px;
  font-size: 24px;
  color: #9da5b2;

  border-right: 1px solid #9da5b2;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tips-template-list:last-child {
  border-right: none;
}

.rightcode-scan {
  width: 166px;
  height: 51px;
  position: absolute;
  z-index: 99;
  right: 0;
  top: 50%;
  margin-top: -25px;
}
.scancode-one {
  animation: sancode1 15s linear infinite;
}

.scancode-two {
  animation: sancode2 5s ease infinite;
}
@keyframes sancode1 {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes sancode2 {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(-360deg);
  }
}
</style>
